import React, { useState, useEffect } from 'react'
import { Card, message, Typography, Tag } from 'antd'
import AdminTable from '../../components/common/AdminTable'
import api from '../../utils/api'
import { formatTz } from '../../utils/timezone'

const { Title } = Typography

const BusinessUsersList = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10
  })

  const columns = [
    {
      title: '店家名稱',
      dataIndex: 'businessName',
      key: 'businessName'
    },
    {
      title: '員工名稱',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: '職位',
      dataIndex: 'employeeType',
      key: 'employeeType',
      render: (type) => <Tag color='blue'>{type}</Tag>
    },
    {
      title: '電子郵件',
      dataIndex: 'email',
      key: 'email'
    },
    {
      title: '電話',
      dataIndex: 'phone',
      key: 'phone'
    },
    {
      title: '加入時間',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date) => formatTz(date, 'YYYY/MM/DD')
    }
  ]

  const fetchData = async (page = 1, pageSize = 10) => {
    setLoading(true)
    try {
      const response = await api.get(
        `/api/admin/business-users?page=${page}&limit=${pageSize}`
      )
      setData(response.data.data)
      setPagination(response.data.pagination)
    } catch (error) {
      message.error('獲取店家用戶數據失敗')
    }
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleTableChange = (pagination) => {
    fetchData(pagination.current, pagination.pageSize)
  }

  return (
    <Card>
      <Title level={2}>店家用戶管理</Title>
      <AdminTable
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </Card>
  )
}

export default BusinessUsersList
